module.exports = __webpack_public_path__ + "img/depmap_svg_V61.d8833a4a.svg";